import { default as ControlChanges } from './ControlChanges'
export default ControlChanges
